export default __webpack_public_path__ + "static/media/car-fixing-4.f0d0ad39.jpg";